import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import Breadcrumbs from '../../Components/Breadcrumbs'
import { useStyles } from './style'
import { Box, Typography, Paper, TextField, Grid, MenuItem, Button, FormControlLabel, RadioGroup, Radio, FormLabel } from '@material-ui/core'
import { useFormik } from 'formik'
import * as yup from 'yup'
import { clearMessage, userSignUp } from '../../AppRedux/actions/Auth'
import { utilService } from '../../Services/UtilService/UtilService'
import { AppButton, DisplayMessage, Loader } from '../../Components'
import _ from 'lodash'
import { COMMON } from '../../utils/constants'
import * as messageTypes from '../../utils/messageTypes'
import { timezones } from '../../utils/timezones'
import Icon from '../../utils/icons'

const ALL = 'ALL'
let validated = false
export const debounceValidateWebsite = _.debounce(async (value, resolve) => {
  await utilService.validateWebsite(value)
    .then(validatedData => {
      validated = true
      resolve(true)
    })
    .catch(error => {
      validated = true
      resolve(false)
    })
}, 1000)
const validationSchema = yup.object({
  company_name: yup
    .string('Enter account name')
    .max(50, 'Account name must be max 50 characters')
    .required('Account name is required'),
  registered_as: yup
    .string('Select Register as')
    .required('Please select Register as'),
  email: yup
    .string('Enter email')
    .email('Enter a valid email')
    .required('Email is required'),
  phone: yup
    .string('Enter phone')
    .matches(/(^[0-9]{10})$/, 'Enter valid phone number')
    .required('Phone is required'),
  name: yup
    .string('Enter full name')
    .required('Full name is required'),
  website: yup
    .string('Enter your website')
    .test("website", "Enter valid website", async (value) => {
      return new Promise((resolve) => debounceValidateWebsite(value, resolve))
    })
    .required('Website is required'),
  address: yup
    .string('Enter address')
    .max(100, 'Address must be max 100 characters')
    .required('Address is required'),
  city: yup
    .string('Enter your city')
    .max(100, 'City must be max 100 characters')
    .required('City is required'),
  state: yup
    .string('Select your state')
    .required('Select your state'),
  country: yup
    .string('Select your country')
    .required('Select your country'),
  timezone: yup
    .string('Select timezone')
    .required('Timezone is required'),
  apiAccess: yup
    .string('Select API access')
    .required('Select API access')
})

function CreateNewAccount(props) {
  const classes = useStyles()
  const [openMessage, setOpenMessage] = useState(false)
  const [open, setOpen] = useState(false)
  const [message, setMessage] = useState('')
  const [messageType, setMessageType] = useState('')
  const [countries, setCountries] = useState({})
  const [states, setStates] = useState({})
  const [timezones, setTimezones] = useState({})
  const [loading, setLoading] = useState(false)

  const formik = useFormik({
    initialValues: {
      company_name: '',
      registered_as: '',
      email: '',
      phone: '',
      name: '',
      website: '',
      address: '',
      city: '',
      state: '',
      country: '',
      timezone: '',
      apiAccess: false,
      gsmAccess: true
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      props.userSignUp(values)
    },
  })

  const getAllCountries = () => {
    setLoading(true)
    utilService.getAllCountries()
      .then(countriesData => {
        setCountries(countriesData)
        setLoading(false)
      })
      .catch(error => {
        setLoading(false)
        setOpen(true)
        setMessageType(messageTypes.INFO)
        setMessage(_.get(error, 'data.error.displayMessage', 'Failed to fetch countries'))
      })
  }

  const handleClose = (event, reason) => {
    if (reason === COMMON.CLICKAWAY) {
      return
    }

    setOpen(false)
    setOpenMessage(false)
  }

  const getAllStates = (country) => {
    setLoading(true)
    utilService.getStateByCountry(country)
      .then(stateData => {
        if (_.isEmpty(stateData)) {
          setStates({ 'ALL': 'ALL' })
          formik.setFieldValue('state', 'ALL')
        } else {
          setStates(stateData)
        }
        setLoading(false)
      })
      .catch(error => {
        setLoading(false)
        setOpenMessage(true)
        setMessageType(messageTypes.INFO)
        setMessage(_.get(error, 'data.error.displayMessage', 'Failed to fetch states'))
      })
  }

  const getTimezones = (country) => {
    setLoading(true)
    utilService.getTimezonesByCountry(country)
      .then(timeZoneData => {
        setTimezones(timeZoneData)
        setLoading(false)
      })
      .catch(error => {
        setLoading(false)
        setOpenMessage(true)
        setMessageType(messageTypes.INFO)
        setMessage(_.get(error, 'data.error.displayMessage', 'Failed to fetch timezones'))
      })
  }

  const handleCountryChange = (e) => {
    formik.setFieldValue([e.target.name], e.target.value)
    formik.setFieldValue('state', '')
    formik.setFieldValue('timezone', '')
    getAllStates(e.target.value)
    getTimezones(e.target.value)
  }

  const renderIcon = (errors, touched) => {
    return validated ? touched ? _.isUndefined(errors) ? <Icon src="circleTick" /> : <Icon src="circleCross" /> : <></> : <></>
  }

  useEffect(() => {
    if (props.message && props.messageType) {
      setOpenMessage(true)
      if (props.messageType === messageTypes.SUCCESS) {
        const clearHistory = setTimeout(() => { props.history.push('/admin') }, 2000)
        return () => clearTimeout(clearHistory)
      }
      const clear = setTimeout(() => {
        props.clearMessage()
      }, 6000)
      return () => clearTimeout(clear)
    }
  }, [props.message, props.messageType])

  useEffect(() => {
    if (!openMessage) {
      props.clearMessage()
    }
  }, [openMessage])

  useEffect(() => {
    props.clearMessage()
    getAllCountries()
  }, [])

  return (
    <>
      <Breadcrumbs value={[{ 'Home': '/' }, { 'Admin': '/admin' }, { 'Create New Account': '' }]} />
      <Loader loading={loading || props.loading} />
      <DisplayMessage open={open} message={message} messageType={messageType} handleClose={handleClose} />
      {props.message && props.messageType && <DisplayMessage open={openMessage} message={props.message} messageType={props.messageType} handleClose={handleClose} />}
      <Box className={classes.headerWrapper}>
        <Typography className={classes.title}>Create New Account</Typography>
      </Box>
      <Paper className={classes.formContainer} elevation={2} >
        <div className={classes.subHeaderWrapper}>Personal Details</div>
        <form onSubmit={formik.handleSubmit}>
          <Grid container spacing={4} className={classes.innerContainer}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                id="full-name"
                name="name"
                label="Full Name"
                value={formik.values.name}
                onChange={formik.handleChange}
                onBlur={(e) => formik.setFieldValue('name', e.target.value.trim())}
                InputProps={{
                  endAdornment: renderIcon(formik.errors.name, formik.touched.name),
                }}
                error={formik.touched.name && Boolean(formik.errors.name)}
                helperText={formik.touched.name && formik.errors.name}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                id="phone"
                name="phone"
                label="Phone"
                value={formik.values.phone}
                onChange={(e) => formik.setFieldValue('phone', e.target.value.trim())}
                InputProps={{
                  endAdornment: renderIcon(formik.errors.phone, formik.touched.phone),
                }}
                error={formik.touched.phone && Boolean(formik.errors.phone)}
                helperText={formik.touched.phone && formik.errors.phone}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                id="email"
                name="email"
                label="Email"
                value={formik.values.email}
                onChange={(e) => formik.setFieldValue('email', e.target.value.trim())}
                InputProps={{
                  endAdornment: renderIcon(formik.errors.email, formik.touched.email),
                }}
                error={formik.touched.email && Boolean(formik.errors.email)}
                helperText={formik.touched.email && formik.errors.email}
              />
            </Grid>
          </Grid>
          <div className={`${classes.subHeaderWrapper} ${classes.mt2}`}>Account Details</div>
          <Grid container spacing={4} className={classes.innerContainer}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                id="companyname"
                name="company_name"
                label="Account Name"
                value={formik.values.company_name}
                onChange={formik.handleChange}
                onBlur={(e) => formik.setFieldValue('company_name', e.target.value.trim())}
                InputProps={{
                  endAdornment: renderIcon(formik.errors.company_name, formik.touched.company_name),
                }}
                error={formik.touched.company_name && Boolean(formik.errors.company_name)}
                helperText={formik.touched.company_name && formik.errors.company_name}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                style={{ textAlign: 'left' }}
                select
                id="register-as"
                name="registered_as"
                label="Register As"
                value={formik.values.registerAs}
                onChange={formik.handleChange}
                InputProps={{
                  classes: { root: classes.input }
                }}
                SelectProps={{
                  MenuProps: {
                    classes: { paper: classes.paper },
                    anchorOrigin: {
                      vertical: "bottom",
                      horizontal: "left"
                    },
                    getContentAnchorEl: null
                  }
                }}
                error={formik.touched.registered_as && Boolean(formik.errors.registered_as)}
                helperText={formik.touched.registered_as && formik.errors.registered_as}
              >
                <MenuItem value='aggregator'>Aggregator</MenuItem>
                <MenuItem value='utility'>Utility</MenuItem>
              </TextField>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                id="address"
                name="address"
                label="Address"
                value={formik.values.address}
                onChange={formik.handleChange}
                onBlur={(e) => formik.setFieldValue('address', e.target.value.trim())}
                InputProps={{
                  endAdornment: renderIcon(formik.errors.address, formik.touched.address),
                }}
                error={formik.touched.address && Boolean(formik.errors.address)}
                helperText={formik.touched.address && formik.errors.address}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                id="city"
                name="city"
                label="City"
                value={formik.values.city}
                onChange={formik.handleChange}
                onBlur={(e) => formik.setFieldValue('city', e.target.value.trim())}
                InputProps={{
                  endAdornment: renderIcon(formik.errors.city, formik.touched.city),
                }}
                error={formik.touched.city && Boolean(formik.errors.city)}
                helperText={formik.touched.city && formik.errors.city}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                select
                fullWidth
                style={{ textAlign: 'left' }}
                id="country"
                name="country"
                label="Country"
                value={formik.values.country}
                onChange={handleCountryChange}
                InputProps={{
                  classes: { root: classes.input }
                }}
                SelectProps={{
                  MenuProps: {
                    classes: { paper: classes.paper },
                    anchorOrigin: {
                      vertical: "bottom",
                      horizontal: "left"
                    },
                    getContentAnchorEl: null
                  }
                }}
                error={formik.touched.country && Boolean(formik.errors.country)}
                helperText={formik.touched.country && formik.errors.country}
              >
                {Object.keys(countries).map(key => (
                  <MenuItem value={key}>{countries[key]}</MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                select
                fullWidth
                style={{ textAlign: 'left' }}
                id="state"
                name="state"
                label="State"
                disabled={!formik.values.country}
                value={formik.values.state}
                onChange={formik.handleChange}
                InputProps={{
                  classes: { root: classes.input }
                }}
                SelectProps={{
                  MenuProps: {
                    classes: { paper: classes.paper },
                    anchorOrigin: {
                      vertical: "bottom",
                      horizontal: "left"
                    },
                    getContentAnchorEl: null
                  }
                }}
                error={formik.touched.state && Boolean(formik.errors.state)}
                helperText={formik.touched.state && formik.errors.state}
              >
                {Object.keys(states).map((state) => (
                  <MenuItem key={state} value={state}>{`${states[state]}${state !== ALL ? ' - ' + state : ''}`}</MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                id="website"
                name="website"
                label="Website"
                value={formik.values.website}
                onChange={(e) => formik.setFieldValue('website', e.target.value.trim())}
                InputProps={{
                  endAdornment: renderIcon(formik.errors.website, formik.touched.website),
                }}
                error={formik.touched.website && Boolean(formik.errors.website)}
                helperText={formik.touched.website && formik.errors.website}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                select
                fullWidth
                style={{ textAlign: 'left' }}
                id="timezone"
                name="timezone"
                label="Time Zone"
                disabled={!formik.values.country}
                value={formik.values.timezone}
                onChange={formik.handleChange}
                InputProps={{
                  classes: { root: classes.input }
                }}
                SelectProps={{
                  MenuProps: {
                    classes: { paper: classes.paper },
                    anchorOrigin: {
                      vertical: "bottom",
                      horizontal: "left"
                    },
                    getContentAnchorEl: null
                  }
                }}
                error={formik.touched.timezone && Boolean(formik.errors.timezone)}
                helperText={formik.touched.timezone && formik.errors.timezone}
              >
                {Object.keys(timezones).map((timezone) => (
                  <MenuItem key={timezone} value={timezone}>{timezone}</MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormLabel component="legend" style={{ marginBottom: '8px' }}>Developer Hub/ GSM Access</FormLabel>
              <RadioGroup aria-label="access" name="access" defaultValue="gsmAccess"
                onChange={(e) => {
                  if (e.target.value === 'gsmAccess') {
                    formik.setFieldValue('gsmAccess', true)
                    formik.setFieldValue('apiAccess', false)
                  }
                  if (e.target.value === 'apiAccess') {
                    formik.setFieldValue('apiAccess', true)
                    formik.setFieldValue('gsmAccess', false)
                  }
                  if (e.target.value === 'both') {
                    formik.setFieldValue('gsmAccess', true)
                    formik.setFieldValue('apiAccess', true)
                  }
                }}>
                <FormControlLabel
                  classes={{ label: classes.customFormLabel }}
                  value="gsmAccess"
                  control={<Radio color="primary" size="small" />}
                  label="Grid Services Manager"
                  labelPlacement="right"
                />
                <FormControlLabel
                  classes={{ label: classes.customFormLabel }}
                  value="apiAccess"
                  control={<Radio color="primary" size="small" />}
                  label="Developer Hub and APIs"
                  labelPlacement="right"
                />
                <FormControlLabel
                  classes={{ label: classes.customFormLabel }}
                  value="both"
                  control={<Radio color="primary" size="small" />}
                  label="Both"
                  labelPlacement="right"
                />
              </RadioGroup>
            </Grid>
          </Grid>
          <Box className={classes.mt4}>
            <hr className={classes.hr} />
          </Box>
          <AppButton className={classes.submitButton} type="submit" text="Submit" fullWidth />
        </form>
      </Paper>
    </>
  )
}

const mapStateToProps = ({ auth, programs }) => {
  const { currentUser, message, messageType, loading } = auth
  const { stateList } = programs
  return { currentUser, stateList, message, messageType, loading }
}

const mapDispatchToProps = dispatch => ({
  userSignUp: payload => dispatch(userSignUp(payload)),
  clearMessage: () => dispatch(clearMessage())
})

export default connect(mapStateToProps, mapDispatchToProps)(CreateNewAccount)